import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { Client } from 'app/core/models/client.model';
import { ClientListFilters } from 'app/core/services/clients.service';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

export class ReportClientOption implements ReportOption {
  value: number[] | number | null = null;

  constructor(value) {
    this.value = value;
  }

  toPostData(options = { paramName: 'clientIds' }) {
    return { [options.paramName]: this.value };
  }
}

@Component({
    selector: 'app-report-client-option',
    templateUrl: './report-client-option.component.html',
    styleUrls: ['./report-client-option.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ReportClientOptionComponent),
        },
    ],
    imports: [ClientSelectComponent, FormsModule]
})
export class ReportClientOptionComponent extends ReportAbstractOptionComponent {
  @Input() label = 'Filter by Client';
  @Input() multiple = true;

  @Input() clientFilters: ClientListFilters;

  selectedClientIds: number[] = [];
  selectedClientId: number | null = null;

  protected updateInternalState(model: ReportClientOption) {
    this.selectedClientIds = [];
    this.selectedClientId = null;

    if (!model || model.value == null) return;

    const v: any = model.value;

    if (typeof v === 'number') {
      this.selectedClientId = v;
      return;
    }
    if (Array.isArray(v) && v.every(x => typeof x === 'number')) {
      this.selectedClientIds = v;
      return;
    }

    // handle old stored filters from local storage?
    if (Array.isArray(v)) {
      this.selectedClientIds = v.map((c: Client) => c.id);
    } else {
      this.selectedClientId = (v as Client).id;
    }
  }

  protected determineModelStateOnChange(): ReportClientOption | null {
    if (this.multiple) {
      return this.selectedClientIds?.length
        ? new ReportClientOption(this.selectedClientIds)
        : null;
    } else {
      return this.selectedClientId != null
        ? new ReportClientOption(this.selectedClientId)
        : null;
    }
  }
}
